import React from 'react';
import { Radio, Mic, Megaphone, User, ClipboardCheck, HelpCircle } from 'lucide-react';
import AppShell from './AppShell';

const NAV_ITEMS = [
  { to: '/operator/session',   icon: Radio,          label: 'Session' },
  { to: '/operator/adhoc',     icon: Mic,            label: 'Ad-Hoc' },
  { to: '/operator/announce',  icon: Megaphone,      label: 'Announce' },
  { to: '/operator/approvals', icon: ClipboardCheck, label: 'Approvals' },
  { to: '/operator/help',      icon: HelpCircle,     label: 'Help' },
  { to: '/operator/profile',   icon: User,           label: 'Profile' },
];

export default function OperatorLayout() {
  return <AppShell roleLabel="Gate Operator" navItems={NAV_ITEMS} />;
}
